import type { JSX, ReactNode } from "react";
import { GRID_BORDER_COLOR } from "./plot-geometry";
import type { PlotLayout } from "./plot-layout";

/**
 * Absolutely-positioned DOM layer whose box edges ARE the plot rect. Rendered inside the panel's
 * `position: relative` container, over the ECharts canvas. Its own `position: absolute` also
 * makes it the containing block for its children, so badges/other chrome can position themselves
 * with small offsets relative to this layer instead of computing absolute panel-space pixels.
 *
 * `pointer-events-none` so it never blocks chart hover/tooltip interaction; interactive children
 * (e.g. unit badges) must opt back in with `pointer-events-auto`.
 */
export function PlotChromeLayer({ layout, children }: { layout: PlotLayout; children?: ReactNode }): JSX.Element {
    return (
        <div
            className={"pointer-events-none absolute border"}
            style={{
                borderColor: GRID_BORDER_COLOR,
                left: layout.gutters.left,
                right: layout.gutters.right,
                top: 0,
                // Needs a bit of a nudge to not clip lines that hit 0 on the y-axis
                bottom: layout.xAxisBandPx - 1,
            }}
        >
            {children}
        </div>
    );
}
